import SignUp from 'Event/auth/SignUp'
import {DesignBreadcrumbs} from 'organization/Event/Page/PageBreadcrumbs'
import Page from 'organization/Event/TemplateEditor/Page'
import React, {useState} from 'react'
import SignUpEnabledSwitch from 'Event/auth/SignUp/SignUpEnabledSwitch'
import Button, {ButtonProps} from 'lib/ui/Button'
import {useEvent} from 'Event/EventProvider'
import {ConfigContext} from 'organization/Event/Configurable'
import {useToggleArray} from 'lib/toggle'
import {useForm} from 'react-hook-form'
import PageSettings from 'Event/auth/SignUp/PageSettings'
import {ObvioEvent} from 'Event'
import {getEventUrl} from 'lib/url'
import styled from 'styled-components'
import {eventRoutes} from 'Event/Routes'
import FileCopyIcon from '@material-ui/icons/FileCopy'
import LanguageSelector from 'organization/Event/LocalizationConfig/LanguageSelector'

interface PageSettingsButtonProps extends Omit<ButtonProps, 'children'> {}

export default function SignUpConfig() {
  const {event} = useEvent()
  const [showingConfig, toggleConfig] = useToggleArray()
  const isSignUpEnabled = event.sign_up_enabled
  const form = useForm()

  return (
    <DesignBreadcrumbs page="Sign Up">
      <Page
        toolbarItems={
          <>
            <LanguageSelector />
            <SignUpEnabledSwitch />
            <PageSettingsButton
              onClick={toggleConfig}
              disabled={!isSignUpEnabled}
            />
            <SignUpUrl event={event} show={isSignUpEnabled} />
          </>
        }
      >
        <ConfigContext.Provider
          value={{showing: showingConfig, toggle: toggleConfig, form}}
        >
          <PageSettings />
          <SignUp />
        </ConfigContext.Provider>
      </Page>
    </DesignBreadcrumbs>
  )
}

function SignUpUrl(props: {event: ObvioEvent; show: boolean}) {
  const {event, show} = props
  const [copied, setCopied] = useState(false)

  if (!show) return null

  const eventUrl = getEventUrl(event)
  const signUpUrl = eventRoutes.signUp

  const url = `${eventUrl}${signUpUrl}`

  const handleCopyClick = () => {
    navigator.clipboard.writeText(url)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <SignUpUrlWrapper>
      {copied && <CopiedText>Copied!</CopiedText>}
      <CopyUrlButton
        variant="outlined"
        color="primary"
        size="small"
        startIcon={<FileCopyIcon style={{fontSize: 14}} />}
        onClick={handleCopyClick}
        aria-label="Copy Signup URL"
      >
        Copy Signup URL
      </CopyUrlButton>
    </SignUpUrlWrapper>
  )
}

function PageSettingsButton(props: PageSettingsButtonProps) {
  return (
    <Button
      variant="outlined"
      fullWidth
      color="primary"
      size="small"
      aria-label="page settings"
      {...props}
    >
      Page Settings
    </Button>
  )
}

const CopiedText = styled.span`
  font-size: 0.875rem;
  color: ${(props) => props.theme.colors.success};
  padding: 0 0.5rem;
  margin-right: 0.5rem;
`
const SignUpUrlWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 10px;
  position: absolute;
  right: 160px;
`
const CopyUrlButton = styled(Button)`
  && {
    color: ${(props) => props.theme.colors.primary};
  }
`
